import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-guidance',
  templateUrl: './help-guidance.component.html',
  styleUrl: './help-guidance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HelpGuidanceComponent {
  @Input() text: string = '';
  @Input() buttonLabel: string = 'View guidance';

  public visible = false;

  get hasText(): boolean {
    return !!this.text?.trim();
  }

  open(): void {
    if (this.hasText) {
      this.visible = true;
    }
  }

  close(): void {
    this.visible = false;
  }
}
